import useEffect from '../useEffect';
/**
 * Automatically scroll to the top when the page is mounted
 * or the states in the dependency array updated.
 */
export function useScrollToTop(dependencyArray = []) {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [...dependencyArray]);
}
